import { Component, Input } from '@angular/core';
import {
  trigger,
  state,
  style,
  animate,
  transition,
} from '@angular/animations';

@Component({
  selector: 'cloudlabs-help-tab',
  templateUrl: './help-tab.component.html',
  styleUrls: ['./help-tab.component.scss'],
  animations: [
    trigger('accordionAnimation', [
      state('void', style({ height: '0', opacity: 0 })),
      state('*', style({ height: '*', opacity: 1 })),
      transition(':enter', [
        style({ height: 0, opacity: 0 }),
        animate('200ms ease-out'),
      ]),
      transition(':leave', [
        animate('200ms ease-in', style({ height: 0, opacity: 0 })),
      ]),
    ]),
  ],
})
export class HelpTabComponent {
  @Input() deploymentID: number;
  @Input() isMylearning: boolean;
  @Input() osInfo: string;
  @Input() pasteInVM: boolean;
  @Input() labTitle: string;
  @Input() supportEmail:string
  @Input() attendeLabDetails: any;

  panelStates: { [key: number]: boolean } = {
    1: false,
    2: false,
    3: false,
    4: false,
  };

  togglePanel(panel: number): void {
    this.panelStates[panel] = !this.panelStates[panel];
  }

  generateSupportMailLink(): string {
    const subject = `Request for Support | Deployment ID: ${this.deploymentID}`;
    const body = `Dear Support Team,

I am encountering an issue while working on the hands-on lab - ${this.labTitle}. Please find the details below:

Deployment ID: ${this.deploymentID}
Issue Description: <Briefly describe the issue you are facing>
Error Messages (if any): <Paste any error messages or screenshots if applicable>

I would appreciate your assistance in resolving this at the earliest. Please let me know if any additional information is required.

Best regards,
<Your Full Name>
<Your Email Address>`;

    const mailtoLink = `mailto:${
      this.supportEmail
    }?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    return mailtoLink;
  }

  get isGridView(): boolean {
    return !this.attendeLabDetails?.LabEnvironmentDisplayStyle ||
           this.attendeLabDetails.LabEnvironmentDisplayStyle === 'Grid';
  }
}
